import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

export const sendVitalsToDashboard = async (metric) => {
  try {
    const db = getFirestore();
    await addDoc(collection(db, "webVitals"), {
      name: metric.name,
      value: metric.value,
      id: metric.id,
      path: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error("Web Vitals logging failed:", err);
  }
};
